module.exports = __webpack_public_path__ + "img/inge-v6-1.026f38f5.png";